import e from "../_virtual/_plugin-vue_export-helper.js";
import { createElementBlock as t, openBlock as n, renderSlot as r } from "vue";
//#region src/schema/LinkButton.vue
var i = {}, a = {
	class: "text-c-2 hover:text-c-1 underline",
	type: "button"
};
function o(e, i) {
	return n(), t("button", a, [r(e.$slots, "default")]);
}
var s = /*#__PURE__*/ e(i, [["render", o]]);
//#endregion
export { s as default };

//# sourceMappingURL=LinkButton.vue.js.map